import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { FeatureAuth } from 'shell/models/feature-auth';
import { AutorizationVM } from 'system/components/operators/form/types';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';

interface FeatureAuthListProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (id: string, value: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
  onBootstrap?: boolean;
  selectedItems?: Array<AutorizationVM>;
}

const FeatureAuthListComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  label = 'Autorizzazione',
  id = 'typeFeature',
  onBootstrap = true,
  selectedItems = [],
}: FeatureAuthListProps): React.ReactElement => {
  const [featureAuth] = useHttpFetch<HttpResponseList<FeatureAuth>, Array<ItemVM>>(
    `${__MANAGEMENT_API_URL__}/tipo-feature-auth`,
    {
      options: {
        method: 'GET',
        abortable: true,
        errorCatching: false,
        loading: false,
      },
      onBootstrap,
      transformer: (response) => {
        return response.data.payload.list.map((item) => ({
          id: item.key.codiceFeature,
          value: item.descrizioneTipoFeature || '',
        }));
      },
    }
  );

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`${id}-label`}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId={`${id}-label`}
        id={id}
        name={id}
        value={value}
        label={required ? `${label} *` : label}
        onChange={(event) =>
          onChange(
            event.target.value,
            (featureAuth?.data as Array<ItemVM>).find(
              (item: ItemVM) => item.id === event.target.value
            )?.value || ''
          )
        }
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {featureAuth?.data
          ? (featureAuth?.data as Array<ItemVM>)
              .filter((item) => !selectedItems.find((selectedItem) => item.id === selectedItem.id))
              .sort((a, b) => a.value?.localeCompare(b.value))
              .map((item: ItemVM) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.value}
                </MenuItem>
              ))
          : undefined}
      </PmiSelect>
    </PmiFormControl>
  );
};

FeatureAuthListComponent.displayName = 'Feature Auth list component';

const FeatureAuthList = memo(FeatureAuthListComponent);

export default FeatureAuthList as typeof FeatureAuthListComponent;
